/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Observable } from 'rxjs';
import { User, UserData } from '../../@core/interfaces/auth/users';
import { tap } from 'rxjs/operators';
import { UserStore } from '../../@core/stores/user.store';
import { Injectable } from '@angular/core';
import { NbJSThemesRegistry, NbThemeService } from '@nebular/theme';

@Injectable()
export class InitUserService {
  constructor(protected userStore: UserStore,
    protected usersService: UserData,
    protected jsThemes: NbJSThemesRegistry,
    protected themeService: NbThemeService) { }

  initCurrentUser(): Observable<User> {
    return this.usersService.getCurrentUser()
      .pipe(tap((user: User) => {
        if (user) {
          this.userStore.setUser(user);

          if (user.settings && user.settings.themeName) {
            if (this.jsThemes.has(user.settings.themeName)
              && !!this.jsThemes.get(user.settings.themeName).variables.initialized) {
              this.themeService.changeTheme(user.settings.themeName);
            }
          }
        }
      }));
  }
}
